import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../v3/Common/Token';

import {
  SendOTPThroughExistingUserUrl,
  addUserThroughExistingCompanyUrl,
  getUserFirmsUrl,
} from '../url';

export const getUserFirmsAction = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getUserFirmsUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const SendOTPThroughExistingUser = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(`${SendOTPThroughExistingUserUrl()}`, data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const addUserThroughExistingCompany = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${addUserThroughExistingCompanyUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
